import { render, staticRenderFns } from "./collectionList.vue?vue&type=template&id=b117c170&scoped=true"
import script from "./collectionList.vue?vue&type=script&lang=js"
export * from "./collectionList.vue?vue&type=script&lang=js"
import style0 from "./collectionList.vue?vue&type=style&index=0&id=b117c170&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b117c170",
  null
  
)

export default component.exports